<template>
   <b-container fluid id="main-container">
     <b-row>
      <b-col xs=12 class='no-padding'>
        <div class="instruction-section">
          <p v-if="$store.getters.language === 'SLO'" class='instruction-section-title'>Semantični premik besede "{{word}}"</p>
          <p v-else class='instruction-section-title'>Semantic change for "{{word}}"</p>
          <p v-if="$store.getters.language === 'SLO'" class='instruction-section-text'> Graf prikazuje distribucijo rab besede za različna časovna obdobja. Vsaka barva označuje določeno gručo rab. Ključne besede na desni povzemajo vsebino posamezne gruče. Kliknite na posamezno gručo na grafu, da dobite seznam vseh rab (stavkov) v tej gruči.</p>
          <p v-else class='instruction-section-text'> The graph is showing words usage distributions for specific time periods. Each color represents a distinct usage cluster. Keywords on the right are summarizing the content of each specific cluster. Click on the specific usage cluster on the graph to obtain a list of usages (sentences) in that cluster.</p>
          <img id='rsdo-logo' v-bind:src="require('../assets/rsdo_logo.png')" alt="rsdo logo">
        </div>
      </b-col>
    </b-row>
    <div id="tableLoadSpinner">
      <b-spinner v-show="loading" type="grow" label="Loading..."></b-spinner>
    </div>
     <div id="plotlydiv" ref="plotlydiv"></div>
     <b-table striped bordered hover 
      id="sentence-table"
      :items="items" 
      :fields="fields" 
      responsive="sm"> 
    </b-table>
    <img id='rsdo-footer' v-bind:src="require('../assets/rsdo_footer.png')" alt="rsdo logo">
    <a v-if="$store.getters.language === 'SLO'" id='rsdo-footer-git' v-bind:href=model_git target="_blank">Link do Github repozitorija</a>
   <a v-else id='rsdo-footer-git' v-bind:href=model_git target="_blank">Link to the Github repository</a>
  </b-container>
</template>

<script>
import Plotly from 'plotly.js-dist';
export default {
  name: "SemanticShiftVisualization",
  components: {},
  watch: {
    language(newLang, oldLang) {
      if (newLang != oldLang) {
        if (newLang === 'SLO') {
          this.tp = 'Časovno obdobje'
          this.ud = 'Distribucija rab'
          this.source = 'Vir'
          this.year = 'Leto'
          this.sent = 'Stavek'
        }
        else {
          this.tp = 'Time period'
          this.ud = 'Usage distribution'
          this.source = 'Source'
          this.year = 'Year'
          this.sent = 'Sentence'
        }
      }
      this.drawGraph()
    }
  },
  mounted() {
    if (this.$store.getters.language === 'SLO') {
      this.tp = 'Časovno obdobje'
      this.ud = 'Distribucija rab'
      this.source = 'Vir'
      this.year = 'Leto'
      this.sent = 'Stavek'
    }
    this.drawGraph()
  },
  data() {
    return {
      perPage: 100,
      currentPage: 1,
      sortBy: 'WD K5 All',
      sortDesc: false,
      items: [],
      fields: [],
      word: "",
      model_git: '',
      loading:true,
      tp:'Time period',
      ud:'Usage distribution',
      source:'Source',
      year:'Year',
      sent:'Sentence',
    };
  },
  computed: {
    rows() {
      return this.items.length
    },
    language() {
      return this.$store.getters.language
    }
  },
  methods: {
    drawGraph() {
      this.word = this.$route.params['word'];
      this.model_git = this.$store.getters.model_git
      var model_id = this.$route.params['model_id'];
      this.$http({url: this.$hostname + '/api/model/' + model_id + '/get', data: {'word': this.word}, method: 'POST' })
      .then(response => { 
        var distrib_info = Object.entries(response.data.model_reponse['distribution_data']['distrib_info'])
        var chunks = response.data.model_reponse['distribution_data']["chunks"]
        var distrib_data = []
        var sent_info = JSON.parse(response.data.model_reponse['distribution_data']['sent_info'])
        var parent = this

        if (this.$store.getters.language === 'SLO') {
          for (var chunk_idx = 0; chunk_idx < chunks.length; chunk_idx++) {
            chunks[chunk_idx] = chunks[chunk_idx].replace("Year", "Leto") 
          }
        }

        for (var i = 0; i < distrib_info.length; i++) {
            var y = distrib_info[i][1]
            var c_id = distrib_info[i][0].split(":")[0].split(" ")[1]
            var name = distrib_info[i][0].split(":")[1]
            distrib_data.push({
              x: chunks,
              y: y,
              name: name,
              c_id: c_id,
              type: 'bar'
            })
        }

        var layout = {
          xaxis: {title: this.tp},
          yaxis: {title: this.ud},
          barmode: 'stack',
          title: '',
          font: {
            family: 'Roboto, sans-serif',
            color: '#4F6675'
          },
          showlegend: true,
          legend: {"orientation": "h", y: -1.2}
        };

        Plotly.newPlot(this.$refs.plotlydiv, distrib_data, layout, {scrollZoom: true});
        this.$refs.plotlydiv.on('plotly_click', function(data){
          var c_id = '';
          for(var i=0; i < data.points.length; i++){
            c_id = data.points[i].data.c_id
          }
          var sent_data = []
          for(var j=0; j < sent_info.length; j++){
            console.log(parseInt(c_id), sent_info[j]['cluster_label'])
            if (parseInt(c_id) === sent_info[j]['cluster_label']) {
              var sent_row = {}
              sent_row[parent.source] = sent_info[j]['doc_id']
              sent_row[parent.year] = sent_info[j]['year_published']
              sent_row[parent.sent] = sent_info[j]['sentence']
              sent_data.push(sent_row)
            } 
          }
          parent.items = sent_data

        });
        this.loading = false
        
      })
      .catch(error => {
        console.error(error);
      });
    }
  }
}
</script>

<style lang="scss">

thead, tbody, tfoot, tr, td, th {
  text-align: left;
  width: 100px;
  vertical-align: middle;
}
pre {
  text-align: left;
  color: #d63384;
}

.instruction-section-title {
  text-align: center;
  margin-top: 10px;
  padding-top: 0px;
  padding-bottom: 0px;
  margin-bottom: 0px;
  font-size: 16px;
  font-weight: 500;
  text-transform: uppercase;
  color: #fff;
}
.instruction-section {
  padding: 20px;
  display: block;
  background-color: #4F6675;
  margin-bottom: 30px;
}

.instruction-section-text {
  text-align: center;
  margin: 10px;
  color: #fff;
  font-size: 14px;
  font-weight: 300;
}

#sentence-table {
  color: #4F6675;
  margin-top: 40px;
}
#plotlydiv {
  color: #4F6675;;
}

#tableLoadSpinner {
  text-align: center;
  margin-top: 16px;
  margin-bottom: 16px;
}

.spinner-grow {
  background-color: #4F6675 !important;
}

#rsdo-logo {
  text-align: center;
  margin: auto;
  display: block;
  width: 50px;
}

#rsdo-footer {
  text-align: center;
  margin: auto;
  display: block;
  width: 50%;
  margin-top: 60px;
}

@media (max-width: 1200px) {
  #rsdo-footer {
      width: 70%;
  }
}

@media (max-width: 1024px) {
  #rsdo-footer {
      width: 95%;
  }
}

#rsdo-footer-git {
  text-align: center;
  margin: auto;
  color: #4F6675;
  display: block;
  padding-top: 10px;
  padding-bottom: 10px;
}

</style>